import * as React from "react";
import { createRoot } from "react-dom/client";
import { Header } from '@elo-ds/ui/dist/Header';

const renderHeader = () => {
    const container = document.getElementById('header-wrapper');
    const dataContainer = document.getElementById('header-data');

    if (container && dataContainer) {
        const hideHeader = dataContainer.getAttribute("data-hideHeader") == "True";
        const languages = dataContainer.getAttribute("data-languages");
        const headButtons = dataContainer.getAttribute("data-headButtons");
        const menu = dataContainer.getAttribute("data-menu");
        const banner = dataContainer.getAttribute("data-banner");
        const closeTitle = dataContainer.getAttribute("data-closeTitle");
        const homeTitle = dataContainer.getAttribute("data-homeTitle");
        const activeLink = dataContainer.getAttribute("data-activeLink");
        const search = dataContainer.getAttribute("data-search");
 
        createRoot(container).render(
            <Header
                hideTopLine={hideHeader}
                languages={JSON.parse(languages)}
                headButtons={JSON.parse(headButtons)}
                menu={JSON.parse(menu)}
                banner={JSON.parse(banner)}
                closeTitle={closeTitle}
                homeTitle={homeTitle}
                activeLink={activeLink}
                search={JSON.parse(search)}
            />
        );
        // Remove styles that were added by the react component
        container.classList.remove("elo-header", "elo-closed-header");
    }
};
renderHeader();
